import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import React, { ReactNode } from "react";

interface ChatLauncherTabProps {
  label: string;
  onClick: () => void;
  ariaLabel?: string;
  icon?: ReactNode;
}

/** Closed-state tab pinned to the viewport edge that opens the chat panel. */
const ChatLauncherTab = ({ label, onClick, ariaLabel, icon }: ChatLauncherTabProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel ?? `Open ${label} chat`}
      className="flex items-center gap-2 rounded-l-lg border border-r-0 border-neutral-200 bg-white px-3 py-2.5 text-neutral-700 shadow-[0_2px_12px_rgba(0,0,0,0.12)] hover:bg-neutral-50 hover:text-primary-600"
    >
      {icon ?? <ChatBubbleLeftRightIcon className="h-5 w-5" />}
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
};

export default ChatLauncherTab;
